import React from 'react';
import DialogComponent from 'components/Dialog';
import {IProxyServer} from '../../../../../types/ProxyServer';
import {DialogTypes} from '../../../../../common/names';
import ProxyForm from 'features/layout/DialogRoutes/dialogs/proxies/ProxyForm';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

type AddEditProxyDialogProps = {
   proxy?: IProxyServer;
   onSubmit: (values: IProxyServer, formikBag: FormOnSubmitHelpers<IProxyServer>) => void;
   onClose: () => void;
};

const AddEditProxyDialog = ({proxy, onSubmit, onClose}: AddEditProxyDialogProps) => {
   return (
      <DialogComponent
         maxWidth="md"
         header={proxy ? DialogTypes.EditProxy.dialogName : DialogTypes.AddProxy.dialogName}
         close={onClose}
      >
         <ProxyForm initialValues={proxy} onSubmit={onSubmit} onClose={onClose} />
      </DialogComponent>
   );
};

export default React.memo(AddEditProxyDialog);
